import { createSlice } from '@reduxjs/toolkit';
import { publicKeyEncryption, save3Ds } from './webxService';

const initialState = {
    encryption: {
        isEncrypting: null,
        isEncrypted: null,
        encryptedCode: null
    },
    html3ds: {
        isLoading: null,
        isSuccess: null,
        html3ds: null,
    }
};

const webxSlice = createSlice({
    name: 'webx',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(publicKeyEncryption.pending, (state) => {
                state.encryption = {
                    ...initialState.encryption,
                    isEncrypting: true,
                };
            })
            .addCase(publicKeyEncryption.rejected, (state, action) => {
                state.encryption = {
                    ...initialState.encryption,
                    isEncrypting: false,
                    isEncrypted: false,
                };
            })
            .addCase(publicKeyEncryption.fulfilled, (state, action) => {
                state.encryption = {
                    ...initialState.encryption,
                    isEncrypting: false,
                    isEncrypted: true,
                    encryptedCode: action.payload.key_encryption,
                };
            });

            // Html3ds
             builder
            .addCase(save3Ds.pending, (state) => {
                state.html3ds = {
                    ...initialState.html3ds,
                    isLoading: true,
                };
            })
            .addCase(save3Ds.rejected, (state, action) => {
                state.html3ds = {
                    ...initialState.html3ds,
                    isLoading: false,
                    isSuccess: false,
                };
            })
            .addCase(save3Ds.fulfilled, (state, action) => {
                state.html3ds = {
                    ...initialState.html3ds,
                    isLoading: false,
                    isSuccess: true,
                    html3ds: action.payload,
                };
            });
    },
});

export default webxSlice.reducer;
